var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeamMembers = function SvgTeamMembers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19820_41785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 19C2 16.791 3.791 15 6 15H10C12.209 15 14 16.791 14 19",
    stroke: "#46D39A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4749 6.02513C11.8417 7.39197 11.8417 9.60804 10.4749 10.9749C9.10804 12.3417 6.89197 12.3417 5.52513 10.9749C4.15829 9.60804 4.15829 7.39197 5.52513 6.02513C6.89197 4.65829 9.10804 4.65829 10.4749 6.02513Z",
    stroke: "#46D39A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14H19C20.657 14 22 15.343 22 17",
    stroke: "#46D39A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2678 6.73223C20.2441 7.70854 20.2441 9.29145 19.2678 10.2678C18.2915 11.2441 16.7085 11.2441 15.7322 10.2678C14.7559 9.29145 14.7559 7.70854 15.7322 6.73223C16.7085 5.75592 18.2915 5.75592 19.2678 6.73223Z",
    stroke: "#46D39A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19820_41785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgTeamMembers as ReactComponent };
export default __webpack_public_path__ + "team-members.svg";